import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { H1 } from 'foundations-components/transitional/components/H1';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import { RequiredProductNames } from '../../../constants/CourseConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UPGRADE_SOURCE_QUERY_PARAM = 'upgradeSource=academy-practical_exercise_required_product';
const PRODUCT_TO_INFO_MAP = {
  [RequiredProductNames.crm]: {
    illustrationName: RequiredProductNames.crm,
    appName: 'browse',
    urlSuffix: `?tab=${RequiredProductNames.crm}&${UPGRADE_SOURCE_QUERY_PARAM}`
  },
  [RequiredProductNames.marketing]: {
    illustrationName: 'marketing-free',
    appName: 'browse',
    urlSuffix: `?tab=${RequiredProductNames.marketing}&${UPGRADE_SOURCE_QUERY_PARAM}`
  },
  [RequiredProductNames.sales]: {
    illustrationName: 'sales-free',
    appName: 'browse',
    urlSuffix: `?tab=${RequiredProductNames.sales}&${UPGRADE_SOURCE_QUERY_PARAM}`
  },
  [RequiredProductNames.paidMarketing]: {
    illustrationName: 'marketing-basic',
    appName: 'browse',
    urlSuffix: `compare/marketing/?product=professional&${UPGRADE_SOURCE_QUERY_PARAM}`
  }
};
const ContentWrapper = styled.div.withConfig({
  displayName: "PracticalExerciseRequiredProduct__ContentWrapper",
  componentId: "sc-9amjky-0"
})(["padding:10%;height:100%;width:100%;"]);
const PracticalExerciseRequiredProduct = ({
  requiredProduct,
  portalId,
  advanceToNextContent,
  onClickProductLink
}) => {
  const productInfo = PRODUCT_TO_INFO_MAP[requiredProduct];
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ContentWrapper, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(H1, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.header`
          })
        }), /*#__PURE__*/_jsx(Illustration, {
          name: productInfo.illustrationName
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "500",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.description`
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(BaseContentControlWrapper, {
      children: [/*#__PURE__*/_jsx(Button, {
        marginInlineEnd: "300",
        onClick: advanceToNextContent,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.skip"
        })
      }), /*#__PURE__*/_jsx(Button, {
        href: `/${productInfo.appName}/${portalId}/${productInfo.urlSuffix}`,
        onClick: onClickProductLink,
        rel: "noopener",
        target: "_blank",
        truncate: true,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.button`
        })
      })]
    })]
  });
};
export default PracticalExerciseRequiredProduct;